var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","id":"title","placeholder":"Add Appointment Title*"},domProps:{"value":_vm.title},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }